import React from 'react';
import IconCheckmark from "../../../../icons/IconCheckmark";
import colors from "../../../../utils/colors";
import { createStyles } from "./styles";

























/**
 * Product/Portfolio Name with selected icon, if it is needed
 */
var BrowsingCardName = function BrowsingCardName(_ref)





{var name = _ref.name,title = _ref.title,wrapperStyles = _ref.wrapperStyles,_ref$showSelectedIcon = _ref.showSelectedIcon,showSelectedIcon = _ref$showSelectedIcon === void 0 ? true : _ref$showSelectedIcon,isPortfolioInProposal = _ref.isPortfolioInProposal;
  var classes = createStyles();
  return /*#__PURE__*/(
    React.createElement("div", { className: wrapperStyles },
    isPortfolioInProposal && showSelectedIcon && /*#__PURE__*/
    React.createElement("span", { className: classes.selectedProductIcon }, /*#__PURE__*/
    React.createElement(IconCheckmark, { width: "5rem", height: "5rem", color: colors.green[600] })),



    name && /*#__PURE__*/React.createElement("h2", { className: classes.productName, dangerouslySetInnerHTML: { __html: name } }),
    title && title));


};

export default BrowsingCardName;
//# sourceMappingURL=index.js.map